module.exports = __webpack_public_path__ + "img/products-3.415ad62.jpg";